// extracted by mini-css-extract-plugin
export default {"approvalRules":"ApprovalRules-module__approvalRules___q37Yj"};